import { Component, OnInit, OnDestroy } from '@angular/core';
import { MdDialog } from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { Subscription } from 'rxjs/Subscription';

import { Meetup } from '../../models/meetup';
import { MoneyPerApplication } from '../../models/money-per-application';
import { MeetupService } from '../../services/meetup.service';
import { ReportService } from '../../services/report.service';
import { AddPaymentComponent } from '../add-payment/add-payment.component';
import { AddSponsorshipComponent } from '../add-sponsorship/add-sponsorship.component';
import { CheckInApplicationComponent } from '../check-in-application/check-in-application.component';
import { ApplicationService } from '../../services/application.service';
import { Application } from '../../models/application';

@Component({
	selector: 'app-money-per-application',
	templateUrl: './money-per-application.component.html',
	styleUrls: ['./money-per-application.component.scss']
})
export class MoneyPerApplicationComponent implements OnInit, OnDestroy {
	private subscriptionManager: Subscription;
	public meetups: Observable<Meetup[]>;
	public selectedMeetup: string;
	public money: Observable<MoneyPerApplication[]>;

	constructor(private applicationService: ApplicationService,
		private meetupService: MeetupService,
		private reportService: ReportService,
		private dialog: MdDialog) {
		this.subscriptionManager = new Subscription();

		this.meetups = this.meetupService.getMeetups();
		this.subscriptionManager.add(this.meetupService.getNextMeetups().subscribe(next => {
			if (next.length > 0) {
				this.selectedMeetup = next[0].$key;
				this.getReport(this.selectedMeetup);
			}
		}));
	}

	ngOnInit() {
	}

	ngOnDestroy() {
		this.subscriptionManager.unsubscribe();
	}

	public getReport(meetupKey: string): void {
		this.money = this.reportService.getMoneyPerCouplesByMeetup(meetupKey);
	}

	public addSponsorship(key: string): void {
		const dialogRef = this.dialog.open(AddSponsorshipComponent, {
			width: '300px'
		});

		this.applicationService.getApplication(key).subscribe(next => {
			dialogRef.componentInstance.updateForm(next);
		});
	}

	public addPayment(key: string): void {
		const dialogRef = this.dialog.open(AddPaymentComponent, {
			width: '300px'
		});

		this.applicationService.getApplication(key).subscribe(next => {
			dialogRef.componentInstance.updateForm(next);
		});
	}

	public checkIn(key: string): void {
		const dialogRef = this.dialog.open(CheckInApplicationComponent, {
			width: '300px'
		});

		this.applicationService.getApplication(key).subscribe(next => {
			dialogRef.componentInstance.updateForm(next);
		});
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/money-per-application/money-per-application.component.ts